import React from "react";
import priorityFlag from "../images/priorityFlag.png";
import { useGlobalContext } from "./SearchBar";

const IrateFlag = () => {
    const { paidFree, displayIrateFlag } = useGlobalContext();
    return (
        <>  
            {(paidFree === "Paid | " && displayIrateFlag) &&
                <li className="priority-flag">
                    <img src={priorityFlag} alt="priorityFlag" height="20px" />
                    Priority
                </li>
            }
        </>
    );
};

export default IrateFlag;
